import { ReactNode } from 'react'
import { CuraHeading } from '@rededor/cura-react'
import { BaseColorWithDeep, NeutralColorWithDeep } from '@/shared/Types/Cura'

import * as S from './styles'

interface TitleProps {
  children: ReactNode
  color?: BaseColorWithDeep | NeutralColorWithDeep
  type?: 'fallback' | 'default'
}

export const Title = ({ children, type = 'default' }: TitleProps) => {
  const lineColor = type === 'default' ? 'primary-lighter' : 'neutral-dark'
  return (
    <S.Title color={lineColor}>
      <CuraHeading size="small" color="neutral-dark" marginBlock="0">
        {children}
      </CuraHeading>
    </S.Title>
  )
}
